import { useContext, useCallback } from 'react';
import { AppContext } from '@blaze-cms/nextjs-components';
const EVENET_PREFIX = 'plugin:page-builder:';
const EVENET_SUFIX = ':sync';
const useAppSyncEventHook = ({
  eventName,
  data,
  props,
  returnFunction
}) => {
  const {
    blazeApp
  } = useContext(AppContext);
  const runHook = useCallback(newData => {
    const eventData = newData || data;
    blazeApp.events.emit(`${EVENET_PREFIX}${eventName}${EVENET_SUFIX}`, {
      data: eventData,
      props
    });
    return eventData;
  }, [blazeApp, eventName, data, props]);
  if (!blazeApp) return {
    data
  };
  if (returnFunction) {
    return {
      data,
      runHook
    };
  }
  runHook();
  return {
    data
  };
};
export default useAppSyncEventHook;
//# sourceMappingURL=use-app-sync-event-hook.js.map